import type { DialogChat } from "../../../types/DialogChat";
import type { GlobalChatMessage } from "./globalChatCache";
import { includesUserId } from "./globalChatConversationActions";

export const getExplicitlyReadableMessageIds = ({
  messages,
  currentUserId,
  inFlightMessageIds = new Set<string>(),
}: {
  messages: GlobalChatMessage[];
  currentUserId?: string;
  inFlightMessageIds?: Set<string>;
}) => {
  if (!currentUserId) {
    return [];
  }

  return messages
    .filter(
      (message) =>
        !message.isLocalOnly &&
        message.sender === "other" &&
        !(message.readBy || []).includes(currentUserId) &&
        !inFlightMessageIds.has(message.messageId),
    )
    .map((message) => message.messageId);
};

export const isDialogChatMutedForUser = (
  chat: Pick<DialogChat, "mutedBy"> | null | undefined,
  currentUserId?: string,
) => includesUserId(chat?.mutedBy, currentUserId);
